import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { environment } from "src/environments/environment";
import { DeleteCompanyModel } from "../../models/members/delete-company.model";
import { SearchMemberCompanyModel } from "../../models/members/search-member-company,model";
import { HttpService } from "../../../share-modul/services/common/http-service";

const CMP_API = environment.apiURL + '/api/adm/Company/';
@Injectable({
    providedIn: 'root'
})
export class MemberCompanyService{
    //#region Fields
    //#endregion

    //#region Constructor

    constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
    }
    //#endregion

    //#region Public Methods
    getallmembercompanies(model: SearchMemberCompanyModel) {
        var url = CMP_API + "getallmembercompanies";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    suspendcompany(model: DeleteCompanyModel) {
        var url = CMP_API + "suspendcompany";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    unsuspendcompany(model: DeleteCompanyModel) {
        var url = CMP_API + "unsuspendcompany";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    getcompanybyid(id: string) {
        var url = CMP_API + 'getcompany?companyId=' + id;
        return this._httpService.httpGet(url)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
     //#endregion

}